import React from "react";
import "./App.css";
import ProcessImage from "./pages/process-image/ProcessImage";

function App() {
	return (
		<div className="app">
			<div></div>
			<ProcessImage />
		</div>
	);
}

export default App;
